import { apiRequest } from "../../util/apiUtils";

export const removeImageReq = async (payload) => {
  try {
    const res = await apiRequest("patch", `page/remove-image`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
